import { Pipe, PipeTransform } from '@angular/core';

import { ToOrdinalNumber } from '@empathy/global/functions';
import { QuestionType, RatingType } from '@empathy/survey/base';
import { Question } from '@empathy/survey-core';

@Pipe({
  name: 'optionValueOrText',
  pure: true
})
export class OptionTextOrDefaultPipe implements PipeTransform {
  transform(valueToMatch: string, question: Question, formatByType: boolean = false): string {
    const selectedOption = question.options?.find((opt) => opt.id === valueToMatch);

    switch (question.type) {
      case QuestionType.NPS: {
        return valueToMatch;
      }
      case QuestionType.RankSort: {
        if (formatByType) {
          return selectedOption?.text ?? valueToMatch;
        }

        if (question.ratingType === RatingType.numeric) {
          return selectedOption?.value ? ToOrdinalNumber(+selectedOption.value) : ToOrdinalNumber(+valueToMatch);
        } else {
          const selectedRank = question.ranks?.find((opt) => opt.id === valueToMatch);
          return selectedRank?.text ?? valueToMatch;
        }
      }
      case QuestionType.Ranking:
        if (formatByType) {
          return selectedOption?.text ?? valueToMatch;
        }

        return selectedOption?.value ? ToOrdinalNumber(+selectedOption.value) : valueToMatch;
      default:
        return selectedOption?.text ?? valueToMatch;
    }
  }
}
